import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.labels')
  .factory('$labels', labelsObjectFactory);

/* @ngInject */
function labelsObjectFactory($bringozFactory: $bringozFactory,
                             LabelsAPI: BringozApi,
                             Labels_DS: DataStoreConfig) {

  function $labels(id: string) {
    return $bringozFactory(id, LabelsAPI, Labels_DS)
  }

  return $labels;
}
